import { render, staticRenderFns } from "./SettingRootPanel.vue?vue&type=template&id=0a8c3bc6&scoped=true"
import script from "./SettingRootPanel.vue?vue&type=script&lang=js"
export * from "./SettingRootPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8c3bc6",
  null
  
)

export default component.exports